import { graphql } from 'gatsby'
import './capital'
import './event'

export const fragment = graphql`
  fragment prismicOpportunityFragmentFull on PrismicOpportunity {
    url
    uid
    type
    prismicId
    lang
    tags
    alternate_languages {
      document {
        ... on PrismicPage {
          url
          lang
        }
      }
    }
    data {
      title {
        text
      }
      override_image {
        url
      }
      override_description
      text_on_card {
        html
      }
      image {
        url
        alt
        thumbnails {
          thumbnail {
            url
            alt
          }
        }
      }
      dagsetning
      type
      amount
      capitals {
        capital {
          document {
            ...prismicCapitalFragmentFull
          }
        }
      }
      events {
        event {
          document {
            ...prismicEventFragmentPartial
          }
        }
      }
      body {
        ... on PrismicOpportunityBodyRichtext {
          ...sliceFragmentPrismicOpportunityBodyRichtext
        }
        ... on PrismicOpportunityBodyHeroMedia {
          ...sliceFragmentPrismicOpportunityBodyHeroMedia
        }
        ... on PrismicOpportunityBodySeo {
            ...sliceFragmentPrismicOpportunityBodySeo
        }
      }
    }
  }

  fragment sliceFragmentPrismicOpportunityBodyRichtext on PrismicOpportunityBodyRichtext {
    primary {
      content {
        html
      }
    }
  }

  fragment sliceFragmentPrismicOpportunityBodySeo on PrismicOpportunityBodySeo {
    id
    slice_type
    primary {
      override_title
      override_description
      override_keywords
      override_image {
        url
      }
    }
  }


  fragment sliceFragmentPrismicOpportunityBodyHeroMedia on PrismicOpportunityBodyHeroMedia {
    id
    slice_type
    primary {
      caption
      single_image {
        url
        alt
      }
      video {
        url
      }
      firstonpage
    }
    items {
      gallery_image {
        url
      }
      image_title
      image_caption
    }
  }
`
